export const AppMode = {
    ROAD: "ROAD",
    TRACK: "TRACK",
};

export const RoadPreset = {
    CUSTOM: "Custom",
    K5: "5K",
    K10: "10K",
    HALF: "Half Marathon",
    FULL: "Full Marathon",
};

export const TrackBase = {
    M200: 200,
    M300: 300,
    M400: 400,
};
